export default __webpack_public_path__ + "static/media/lovelockdownsubhas.857dfd91.jpeg";